stickyCta();

function stickyCta() {
	if ($('.template-product').length) {
		$(window).on('scroll', function () {
			const winScrollTop = $(window).scrollTop() + 500;
			const triggerOffset = $('.js-sticky-cta-trigger').offset();

			if (winScrollTop >= triggerOffset.top) {
				$('.js-sticky-cta').addClass('expanded');
			} else {
				$('.js-sticky-cta').removeClass('expanded');
			}
		});
	}
}
